<template>
    <section class="filters-container">
        <div class="left-filters">
            <div class="filter">
                <span class="fw-bold pb-1 label">Organization</span>
                <MultiSelect
                    classes="first-btn"
                    :dropDownOptions="agencyMultiSelectOptions"
                    labelText="Organizations"
                    :selectedOptions="selectedAgencies"
                    v-on:updateBranches="updateBranches"
                />
            </div>
            <div class="filter">
                <span class="fw-bold pb-1 label">Branches</span>
                <BranchDefaultFilter
                    classes="first-btn"
                    :check-all-by-default="true"
                    :selected-branches="selectedBranches"
                    v-on:updateBranches="handleBranchesOnChange"
                    :selected-agencies-name="selectedAgenciesName"
                />
            </div>
            <div class="filter">
                <div class="fw-bold pb-1 label">Status</div>
                <select class="form-select pl-1 first-btn" name="patient-status" v-model="selectedPatientStatus">
                    <option :value="null">All</option>
                    <option v-for="[key, value] in enumToMap(patientStatusEnums)" :value="value.value" :key="key">
                        {{ value.name }}
                    </option>
                </select>
            </div>
            <div class="filter">
                <span class="fw-bold pb-1 label"> Patient Search</span>
                <input type="text" class="form-control first-btn" placeholder="Patient Name or MRN" v-model="term" />
            </div>
        </div>
    </section>
</template>

<style src="./CommonFilters.scss"></style>
<script src="./CommonFilters.ts"></script>
